import type { Tokens } from '../../../theming/types'
import { styles } from '../../../utilities'

const TextBoxElement = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  minWidth: '30px',
} as const

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      textBoxStartElement: {
        ...TextBoxElement,
        color: tokens.iconColorDefault,
      },

      textBoxEndElement: {
        ...TextBoxElement,
        color: tokens.iconColorDefault,
      },

      innerWrap: {
        display: 'flex',
      },

      help: {
        marginInlineStart: '4px',
      },
    },

    disabled: {
      textBox: {
        color: tokens.formElementTextColorDisabled,
        cursor: 'not-allowed',
      },

      icon: {
        svg: {
          opacity: tokens.opacityDisabled,
        },

        'button:disabled': {
          opacity: '0.5',
        },
      },
    },

    hideError: {
      alignSelf: 'center',
      marginInlineStart: '8px',

      'span > svg': {
        marginInlineEnd: 0,
      },
    },

    hideErrorText: {
      ...styles.visuallyHidden,
    },
  } as const
}
